export const BOLD_MARK = 'bold'
export const COLOUR_MARK = 'colour'
export const ITALIC_MARK = 'italic'
export const ALIGN_MARK = 'align'
export const UNDERLINE_MARK = 'underline'
